export const LOGO_MEJIA_BASE64='';